import React from 'react';
import { Star, BadgeCheck } from 'lucide-react';
export function HeroSection() {
  return <header className="mb-8" data-id="element-363">
      {/* Breadcrumb */}
      <nav className="text-sm text-gray-500 mb-4" data-id="element-364">
        <span className="hover:underline cursor-pointer" data-id="element-365">Home</span>
        <span className="mx-1" data-id="element-366">&gt;</span>
        <span className="hover:underline cursor-pointer" data-id="element-367">Women's Health</span>
        <span className="mx-1" data-id="element-368">&gt;</span>
        <span className="text-gray-700" data-id="element-369">Lymphatic Support</span>
      </nav>

      {/* Main Headline */}
      <h1 className="advertorial-headline text-3xl md:text-[40px] text-gray-900 mb-5 leading-tight" data-id="element-370">
        Why Do Your Legs Feel Fine When You Wake Up... But Like Heavy, Swollen
        Tree Trunks by 3PM?
      </h1>

      {/* Subheadline with underline */}
      <h2 className="advertorial-subheadline text-lg md:text-xl text-gray-800 mb-6 font-normal" style={{
      textDecorationColor: '#21afa1'
    }} data-id="element-371">
        A Lymphatic Health Specialist Finally Explains What's Really Happening
        (And Why the 6-Botanical Solution Is Changing Everything)
      </h2>

      {/* Rating */}
      <div className="flex items-center gap-3 mb-6" data-id="element-372">
        <div className="flex text-yellow-500" data-id="element-373">
          <Star className="w-5 h-5 fill-current" data-id="element-374" />
          <Star className="w-5 h-5 fill-current" data-id="element-375" />
          <Star className="w-5 h-5 fill-current" data-id="element-376" />
          <Star className="w-5 h-5 fill-current" data-id="element-377" />
          <Star className="w-5 h-5 fill-current" data-id="element-378" />
        </div>
        <span className="text-gray-700 font-medium" data-id="element-379">4.8 out of 5</span>
        <span className="text-[#21afa1] font-semibold" data-id="element-380">4,127 Ratings</span>
      </div>

      {/* Author Section */}
      <div className="flex items-start gap-3 mb-8 pb-6 border-b border-gray-200" data-id="element-381">
        {/* Author Photo - Dr. Maria Castellanos */}
        <img src="https://cdn.magicpatterns.com/uploads/h6aJiR4XXiJRW5ri8NK5g7/ChatGPT_Image_5_Φεβ_2026,_04_04_25_μ.μ..png" alt="Dr. Maria Castellanos" className="w-12 h-12 rounded-full object-cover border-2 border-gray-200 flex-shrink-0" data-id="element-382" />
        <div className="flex-1" data-id="element-383">
          <div className="flex items-center gap-2" data-id="element-384">
            <span className="font-semibold text-gray-900" data-id="element-385">
              By Dr. Maria Castellanos
            </span>
            <BadgeCheck className="w-5 h-5 text-[#21afa1] fill-[#21afa1]" data-id="element-386" />
          </div>
          <p className="text-sm text-gray-600" data-id="element-387">
            Lymphatic Health Specialist & Vascular Wellness Expert | February 5,
            2026 | 8:42 am EST
          </p>
        </div>
      </div>

      {/* Hero Image */}
      <div className="relative w-full rounded-lg overflow-hidden mb-8" data-id="element-388">
        <img src="https://cdn.magicpatterns.com/uploads/oqmSDpoJG3DtCjkwJovn9L/ChatGPT_Image_5_Φεβ_2026,_03_59_23_μ.μ..png" alt="Woman experiencing leg discomfort while sitting on couch" className="w-full h-auto object-cover" data-id="element-389" />
      </div>
    </header>;
}